import { render, staticRenderFns } from "./PhoneNumberInput.vue?vue&type=template&id=240454b9&scoped=true"
import script from "./PhoneNumberInput.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInput.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberInput.vue?vue&type=style&index=0&id=240454b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240454b9",
  null
  
)

export default component.exports